import { render } from "./request-info-card.vue?vue&type=template&id=01177418&scoped=true"
import script from "./request-info-card.vue?vue&type=script&lang=js"
export * from "./request-info-card.vue?vue&type=script&lang=js"

import "./request-info-card.vue?vue&type=style&index=0&id=01177418&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01177418"]])

export default __exports__